import type { MatchedSiteMaterialV2 } from 'api';

import { DEFAULT_PAYLOAD_SIZE } from '../../constants';

export const getInitialTonnesPerLoad = (siteMaterial: MatchedSiteMaterialV2): number => {
  return Number(
    siteMaterial.default_payload_size || siteMaterial.material_spec.default_payload_size || DEFAULT_PAYLOAD_SIZE
  );
};
